import {
	useEffect,
	useRef,
	useCallback,
	type SyntheticEvent,
	type MouseEvent,
	type KeyboardEvent,
} from 'react';
// eslint-disable-next-line jira/wrm/no-load-bridge
import { loadBridge } from '@atlassian/jira-common-bridge/src';

export const createReportUrl = (projectKey: string, reportType: string) =>
	`${__SPA__ ? '/jira/servicedesk' : ''}/projects/${projectKey}/reports${reportType}`;

export const useLegacySpaClickHandler = () => {
	const pushStateNavigatorRef = useRef<unknown>(null);

	useEffect(() => {
		// eslint-disable-next-line jira/wrm/no-load-bridge
		loadBridge({
			name: 'servicedesk/internal-api/core/util/push-state-navigator/push-state-navigator',
			shouldLogError: false,
		})
			.then((result) => {
				pushStateNavigatorRef.current = result;
			})
			.catch(() => {
				// silently dies when the required module is not available in this context
			});
	});

	return useCallback(
		(
			e:
				| SyntheticEvent
				| MouseEvent<HTMLAnchorElement>
				| KeyboardEvent<HTMLAnchorElement>
				| MouseEvent<EventTarget>
				| KeyboardEvent<EventTarget>,
		) => {
			const href: string | undefined =
				// @ts-expect-error - TS2339 - Property 'href' does not exist on type 'EventTarget | (EventTarget & Element) | (EventTarget & HTMLAnchorElement)'. | TS2339 - Property 'href' does not exist on type 'EventTarget | (EventTarget & Element) | (EventTarget & HTMLAnchorElement)'.
				typeof e.currentTarget.href === 'string' ? e.currentTarget.href : undefined;

			const openInNewTab =
				// @ts-expect-error - TS2339 - Property 'metaKey' does not exist on type 'KeyboardEvent<HTMLAnchorElement> | SyntheticEvent<Element, Event> | MouseEvent<HTMLAnchorElement, MouseEvent> | MouseEvent<...> | KeyboardEvent<...>'. | TS2339 - Property 'ctrlKey' does not exist on type 'KeyboardEvent<HTMLAnchorElement> | SyntheticEvent<Element, Event> | MouseEvent<HTMLAnchorElement, MouseEvent> | MouseEvent<...> | KeyboardEvent<...>'. | TS2339 - Property 'button' does not exist on type 'KeyboardEvent<HTMLAnchorElement> | SyntheticEvent<Element, Event> | MouseEvent<HTMLAnchorElement, MouseEvent> | MouseEvent<...> | KeyboardEvent<...>'. | TS2339 - Property 'button' does not exist on type 'KeyboardEvent<HTMLAnchorElement> | SyntheticEvent<Element, Event> | MouseEvent<HTMLAnchorElement, MouseEvent> | MouseEvent<...> | KeyboardEvent<...>'.
				e.metaKey === true || e.ctrlKey === true || (e.button != null && e.button === 1);

			if (href == null || href === '' || e.defaultPrevented || openInNewTab) {
				return;
			}

			if (pushStateNavigatorRef.current) {
				// @ts-expect-error - TS2571 - Object is of type 'unknown'.
				const willNavigate = pushStateNavigatorRef.current.navigate(href);
				if (willNavigate) e.preventDefault();
			}
		},
		[],
	);
};
